var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EnvelopeSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375 4.375C2.375 4.02982 2.65482 3.75 3 3.75H18C18.3452 3.75 18.625 4.02982 18.625 4.375V15C18.625 15.3315 18.4933 15.6495 18.2589 15.8839C18.0245 16.1183 17.7065 16.25 17.375 16.25H3.625C3.29348 16.25 2.97554 16.1183 2.74112 15.8839C2.5067 15.6495 2.375 15.3315 2.375 15V4.375ZM3.625 5V15H17.375V5H3.625Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53928 3.95268C2.77253 3.69823 3.16788 3.68104 3.42233 3.91428L10.5 10.4021L17.5777 3.91428C17.8321 3.68104 18.2275 3.69823 18.4607 3.95268C18.694 4.20713 18.6768 4.60248 18.4223 4.83573L10.9223 11.7107C10.6834 11.9298 10.3166 11.9298 10.0777 11.7107L2.57768 4.83573C2.32323 4.60248 2.30604 4.20713 2.53928 3.95268Z",
    fill: "#BDBDBD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.c548a3e8c07d4964dac3c064ec809442.svg";
export { ForwardRef as ReactComponent };